/*
 * AI 帮填埋点 — 选中类型推断
 *
 * spec(ai_form_filler_tracking.md):ai_fill 事件的 string1 字段枚举:
 *   column / row / text_cell / image_cell_empty / image_cell_filled
 *
 * 由 SelectedContent 的 selectionShape + source + cellState 派生.
 * 抽到独立文件供 DocumentPreview(click 时埋)和 work(result 时埋)共用,
 * 保证 click 跟 result 上报的 kind 完全一致.
 */

export type AiFillSelectionKind =
  | 'column'
  | 'row'
  | 'text_cell'
  | 'image_cell_empty'
  | 'image_cell_filled'

export function pickAiFillSelectionKind(content: any): AiFillSelectionKind {
  // content.source: cell-click / cell-range / image-selection / text-selection
  // content.cellState: empty / image / text / all-empty / all-image / all-text
  // content.selectionShape: whole-col / whole-row / cell / range / ...
  if (content?.selectionShape === 'whole-col') return 'column'
  if (content?.selectionShape === 'whole-row') return 'row'
  if (content?.source === 'cell-click') {
    if (content.cellState === 'image') return 'image_cell_filled'
    if (content.cellState === 'empty') return 'image_cell_empty'
    return 'text_cell'
  }
  return 'text_cell'
}
